define('all/communicationbar',['jquery', 'all/jquery/jquery.cookie'], function($) {
	'use strict';
	// TODO: javascript
	window.CommunicationBar = (function() {
		var state = {};
		var shown = {bottom: 0};
		var hidden = {bottom: -70};
		var duration = 500;

		var loadState = function() {
			var jsonState = $.cookie('communication-bar');
			if (jsonState) {
				state = $.parseJSON(jsonState) || {};
			}
		};

		var saveState = function() {
			$.cookie('communication-bar', JSON.stringify(state), {'path': '/'});
		};

		var clearState = function() {
			state = {};
			$.cookie('communication-bar', null, {'path': '/'});
		};

		var bar = function() {
			return $('.communication-bar');
		};

		var setMessage = function() {
			var $bar = bar();
			$bar.find('p').hide();
			$bar.find('p#cb-' + state.contentKey).show();
		};

		var setCommunicationMessage = function() {
			var $bar = bar();
			$bar.find('p').hide();
			$bar.find('p#cb-' + state.contentKey).html(state.communicationMessage);
			$bar.find('p#cb-' + state.contentKey).show();
		};

		$(function() {
			loadState();
			if (state.open && state.contentKey === 'communication') {
				setCommunicationMessage();
				bar().css(shown);
			}
			else if (state.open && (state.contentKey === 'deposit' || state.contentKey === 'register')) {
				setMessage();
				bar().css(shown);
			}
			else {
				bar().css(hidden);
			}
			bar().css({display: 'block'});
			$('.cb-message-hide').click(function() {
				clearState();
				bar().animate(hidden, duration);
			});
		});

		return {
			displayMessage: function(contentKey, communicationmessage) {
				var showMessage = function() {
					state.open = true;
					state.contentKey = contentKey;
					state.communicationMessage = communicationmessage;
					saveState();
					if (state.communicationMessage) {
						setCommunicationMessage();
					}
					else {
						setMessage();
					}
					bar().animate(shown, duration);
				};
				if (state.open && state.contentKey !== contentKey) {
					bar().animate(hidden, duration, showMessage);
				} else {
					showMessage();
				}
			},
			responseHasError: function(response) {
				return response.ICON === '/static/img/myacc_icon_error.gif';
			},
			clearState: clearState
		};
	})();

	return window.CommunicationBar;
});



